module.exports = __webpack_public_path__ + "img/skyline-london-eye.11bb6a4.png";